import { Button, Icon } from '@mercator-gcp/grout';
import { useExportCollection } from 'hooks/useExportCollection';
import { useSelectedLeadFilters } from 'hooks/useLeadTableFiltering';

const CSV_EXPORT_BUTTON_TEXT = 'Export to CSV';

type Props = {
  collectionId: number;
  onMutate?: (clickText?: string) => void;
  onSuccess?: (data: string | null) => void;
};

const ButtonExportCollectionToCSV = ({ collectionId, onMutate, onSuccess }: Props) => {
  const { selectedLeadFilters } = useSelectedLeadFilters();
  const { exportToCSV } = useExportCollection({
    selectedFilterCategories: selectedLeadFilters,
    onMutate: () => onMutate?.(CSV_EXPORT_BUTTON_TEXT),
    onSuccess,
  });

  return (
    <Button
      variant="secondary"
      startAdornment={!exportToCSV.isLoading && <Icon name={Icon.Name.Download} />}
      onClick={() => exportToCSV.mutate(collectionId)}
      isLoading={exportToCSV.isLoading}
    >
      {CSV_EXPORT_BUTTON_TEXT}
    </Button>
  );
};

export default ButtonExportCollectionToCSV;
